// extracted by mini-css-extract-plugin
module.exports = {"container":"PlanoItens_container__2LYa2","refeicoes":"PlanoItens_refeicoes__1nIQM"};